<template>
  <div>
    <modal-provider
      name="map-modal"
      class="vue-js-modal"
      :fullscreen-breakpoint="1100"
      @closed="onModalClose"
      height="auto"
      :width="1400"
      @before-open="beforeOpen"
    >
      <template #modal-heading>
        <div class="delivery__title-wrap">
          <p class="modal__title">{{ modalTitle }}</p>
          <GeoSelectCity v-if="isProduct"
                         class="delivery__select-city"
                         check-availability
                         type="select" />
          <div class="map-modal__mobile-nav">
            <div
              class="map-modal__mobile-nav--map"
              :class="{ 'is-active': isMapActive }"
              @click="SET_IS_MAP_TAB_ACTIVE_ACTION(true)"
            >
              <span>{{ $t('map_modal_map_title') }}</span>
            </div>
            <div
              class="map-modal__mobile-nav--list"
              :class="{ 'is-active': !isMapActive }"
              @click="SET_IS_MAP_TAB_ACTIVE_ACTION(false)"
            >
              <span>{{ $t('map_modal_list_title') }}</span>
            </div>
          </div>
        </div>
      </template>
      <div class="delivery__map-modal">
        <VueMap
          v-if="selectedUserLocation"
          :our-spots-list="ourSpotsInfo"
          :spots-list="spotsInfo"
          @dragstart="dragStart"
          @dragend="dragEnd"
          @selectSpot="selectSpot"
          :our-mail-name="ourMailName"
          :mail-name="mailName"
        />
      </div>
    </modal-provider>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import VueMap from '../../map/VueMap'
import { sortDeliverySpotsByDistance, formattedDeliveryInfo } from '@/mixins'
import GeoSelectCity from '@/components/user-geo/GeoSelectCity'

export default {
  name: 'MapModal',
  components: {
    GeoSelectCity,
    VueMap
  },
  data () {
    return {
      spotsInfo: [],
      mailName: null,
      ourMailName: null,
      ourSpotsInfo: [],
      preSelectedSpot: null,
      isProduct: this.$constants.IS_PRODUCT,
      isManagerCheckout: this.$constants.IS_MANAGER_CHECKOUT
    }
  },
  mixins: [sortDeliverySpotsByDistance, formattedDeliveryInfo],
  computed: {
    ...mapGetters(['selectedSpot']),
    ...mapState({
      formData: state => state.checkout.formData,
      isMapActive: state => state.deliveryForm.isMapTabActive,
      bounds: state => state.map.bounds,
      markers: state => state.map.markers,
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      checkAvailabilitySpotsInfo: state => state.productInfo.availabilityInShops,
      isAvailableShopInSelectedCity: state => state.productInfo.isAvailableShopInSelectedCity,
      popularCities: state => state.geoLocation.popularCities
    }),
    modalTitle () {
      if (this.isProduct) {
        return this.isAvailableShopInSelectedCity
          ? this.$t('reserve_map_title')
          : this.$t('reserve_map_title_nearest')
      }
      if (this.mailName === 'novaPoshtaWarehouse') {
        return this.$t('choose_nova_poshta_warehouse')
      } else if (this.mailName === 'novaPoshtaParcel') {
        return this.$t('choose_nova_poshta_parcel')
      } else if (this.mailName === 'pickup') {
        return this.$t('choose_DM_warehouse')
      } else return this.$t('choose_ukrposhta_warehouse')
    }
  },
  methods: {
    ...mapActions([
      'SET_FORM_DATA',
      'FETCH_PAYMENT_TYPE',
      'SET_IS_MAP_TAB_ACTIVE_ACTION',
      'OPEN_INFO_WINDOW',
      'CREATE_MARKERS',
      'SET_MAP_ACTION',
      'SET_SELECTED_SPOT_ACTION',
      'SET_USER_MARKER_ACTION',
      'SET_CITY_FROM_GEO_SELECTED_ACTION',
      'FETCH_DELIVERY_CITIES'
    ]),
    ...mapActions('deliveryNew', [
      'SET_SELECTED_SPOT'
    ]),
    onModalClose () {
      this.SET_CITY_FROM_GEO_SELECTED_ACTION(false)
      this.SET_USER_MARKER_ACTION(null)
    },
    beforeOpen (event) {
      if (!this.popularCities && this.isProduct) {
        // eslint-disable-next-line no-return-assign
        this.FETCH_DELIVERY_CITIES().then(response => this.$store.commit('SET_POPULAR_CITIES', response.cities))
      }

      this.mailName = event.params.mailName
      this.spotsInfo = this.sortDeliverySpotsByDistance(event.params.spots)
      this.ourMailName = event.params.ourSpotsMailName
      this.ourSpotsInfo = event.params.ourSpots
      this.preSelectedSpot = event.params?.preSelectedSpot ? event.params.preSelectedSpot : null
    },
    closeModal () {
      this.$modal.hide('map-modal')
    },
    selectSpot (spot) {
      this.SET_SELECTED_SPOT(spot)
      // if (this.isManagerCheckout) {
      //   // Выбирает отдел, записывает его в стор и local storage и закрывает модалку
      //   this.SET_FORM_DATA({ deliveryInfo: { deliverySpot: spot } })
      //
      //   if (this.formData.deliveryType.methodId === 1) {
      //     this.FETCH_PAYMENT_TYPE({
      //       storeUid: spot.uid,
      //       cityId: this.formData.city.id,
      //       methodId: this.formData.deliveryType.methodId
      //     })
      //   }
      // }
    }
  },
  watch: {
    userGeo (value) {
      if (this.map && !this.isMapMoved) {
        for (let i = 0; i < this.spotsInfo.length; i++) {
          if (this.isCityFromGeo(value, this.spotsInfo[i]) && !this.isCityFromGeoSelected) {
            this.SET_CITY_FROM_GEO_SELECTED_ACTION(true)
            break
          }
        }
        this.map.setZoom(15)
        this.map.setCenter({ lat: value.latitude, lng: value.longitude })
        this.spotsInfo = this.filteredSpots(this.spotsInfo)
      }
    },
    isMapActive (value) {
      if (value && !(this.formData.deliveryInfo && this.formData.deliveryInfo.deliverySpot)) {
        this.$nextTick(() => {
          this.map.fitBounds(this.bounds)
        })
      }
    },
    checkAvailabilitySpotsInfo (value, prevValue) {
      if (value !== prevValue) {
        this.spotsInfo = this.sortDeliverySpotsByDistance(this.formatDeliverySpotsInfo(value, 'availability'))
      }
    },
    preSelectedSpot (uid) {
      if (this.isProduct && uid) {
        const filteredSpots = this.spotsInfo.filter(spot => spot.storeUid === uid)

        if (filteredSpots.length) {
          this.SET_SELECTED_SPOT_ACTION(filteredSpots[0])
        }
      }
    }
  },
  mounted () {
    if (!this.isProduct && this.formData.deliveryInfo && this.formData.deliveryInfo.deliverySpot) {
      this.SET_SELECTED_SPOT_ACTION(this.formData.deliveryInfo.deliverySpot)
    }
  }
}
</script>

<style scoped lang="sass">

::v-deep
  .modal-body
    padding: 0
    overflow: hidden
  .modal-heading
    padding-right: 20px
    +mmin(450)
      padding-right: 30px
  .modal__title
    padding-right: 20px
    +mmax(1100)
      font-size: 22px
    +mmax(900)
      font-size: 20px
    +mmax(600)
      font-size: 16px

.delivery__map
  width: 100%
  height: 730px

  +mmax(1100)
    height: 100vh

  +mmax(900)
    height: calc(100vh - 90px)

  &--hidden
    display: none

  &--visible
    display: block

.delivery__map-modal
  display: flex

.delivery__map-modal--title
  position: relative

.delivery__title-wrap
  display: flex
  flex-flow: column

  +mmin(1101)
    align-items: center
    flex-flow: row nowrap

.delivery__select-city
  width: 100%
  margin: 20px 0 0
  order: 1

  +mmin(1101)
    max-width: 300px
    margin: 0 0 0 20px

.map-modal__mobile-nav
  width: 100%
  display: flex
  flex-flow: row-reverse
  justify-content: space-between
  order: 0
  margin: 20px 0 0
  background-color: #f5f5f5
  padding: 4px
  border-radius: 3px

  &--map, &--list
    width: 49%
    text-align: center
    font-size: 14px
    line-height: 18px
    padding: 8px
    background-color: transparent
    cursor: pointer

  .is-active
    background-color: $white-text-color
    border-radius: 3px
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05)

  +mmin(1101)
    display: none
</style>
